import { Facebook, Instagram, Youtube, Star, Home, Music2 } from "lucide-react";
import { useSettings } from "@/lib/useSettings";

const NETWORKS = [
  ["facebook", "Facebook", Facebook],
  ["instagram", "Instagram", Instagram],
  ["tiktok", "TikTok", Music2],
  ["youtube", "YouTube", Youtube],
  ["google", "Google reviews", Star],
  ["nextdoor", "Nextdoor", Home],
];

export const SocialLinks = ({ dark = false, className = "" }) => {
  const s = useSettings();
  if (!s) return null;
  return (
    <div className={`flex flex-wrap gap-2 ${className}`} data-testid="social-links">
      {NETWORKS.filter(([k]) => s[k]).map(([k, label, Icon]) => (
        <a key={k} href={s[k]} target="_blank" rel="noreferrer" aria-label={label} title={label} data-testid={`social-${k}`}
          className={`grid h-9 w-9 place-items-center rounded-full border transition-colors ${dark ? "border-white/20 text-white hover:border-[#F2B91C] hover:bg-[#F2B91C] hover:text-[#0E1F3F]" : "border-[#DDE2EA] text-[#0E1F3F] hover:border-[#0E1F3F] hover:bg-[#0E1F3F] hover:text-white"}`}>
          <Icon size={16} />
        </a>
      ))}
    </div>
  );
};
